import React, { memo } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  makeStyles,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { Trackable } from "@dpdgroupuk/react-event-tracker";

import palette from "../styles/palette";
import { View } from "../Base";

const useStyles = makeStyles(({ typography }) => ({
  paper: {
    minWidth: typography.pxToRem(540),
    maxWidth: typography.pxToRem(540),
    minHeight: typography.pxToRem(160),
    borderRadius: 6,
  },
  title: {
    backgroundColor: palette.lightGrey,
    color: palette.typography.black.high,
    fontWeight: "bold",
    padding: `${typography.pxToRem(12)} ${typography.pxToRem(
      60
    )} ${typography.pxToRem(12)} ${typography.pxToRem(20)}`,
    "& h2": {
      lineHeight: typography.pxToRem(24),
      fontSize: typography.pxToRem(18),
    },
  },
  content: {
    padding: `${typography.pxToRem(16)} ${typography.pxToRem(20)}`,
    fontSize: typography.pxToRem(14),
    display: "flex",
    justifyContent: "center",
  },
  actions: {
    padding: `${typography.pxToRem(16)} ${typography.pxToRem(
      20
    )} ${typography.pxToRem(20)}`,
  },
  closeContainer: {
    position: "absolute",
    right: typography.pxToRem(16),
    top: typography.pxToRem(12),
  },
  closeIcon: {
    fontSize: typography.pxToRem(18),
    color: palette.typography.black.solid,
  },
}));

const SimpleModal = ({
  title,
  children,
  actions,
  open,
  onClose,
  DialogProps,
  loadId,
}) => {
  const classes = useStyles();

  return (
    <Trackable loadId={loadId} modal>
      <Dialog
        open={open}
        onClose={onClose}
        PaperProps={{ className: classes.paper }}
        {...DialogProps}
      >
        <DialogTitle className={classes.title}>
          {title}
          <View className={classes.closeContainer}>
            <IconButton
              size="small"
              className={classes.closeButton}
              onClick={onClose}
            >
              <CloseIcon className={classes.closeIcon} />
            </IconButton>
          </View>
        </DialogTitle>
        <DialogContent className={classes.content}>{children}</DialogContent>
        {actions && (
          <DialogActions className={classes.actions}>{actions}</DialogActions>
        )}
      </Dialog>
    </Trackable>
  );
};

export default memo(SimpleModal);
